import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {

  constructor(
    public modalCtrl: ModalController,
    public authService: AuthService
  ) { }

  ngOnInit() { }

  ionViewDidEnter() {

  }


  logout() {
    this.authService.logout().then(() => this.closeModal());
  }

  deleteAccount(){
    this.authService.deleteAccount(this.authService.currentUser.id);
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

}
